module.exports = __webpack_public_path__ + "media/images/swines/Mummified swine fetus after intrauterine death.jpg";